// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2xE8S","footer":"ModalInfo_footer__CsacI"};